import React from 'react';

import { useIntl } from 'react-intl';
import { Col, DatePicker, Radio, Row, Select } from 'antd';
import classnames from 'classnames';
import moment from 'moment';

import { disableCalendarDatesAfterToday } from '@src/packages/utils/dates';
import PropTypes from 'prop-types';

import Title from 'components/BoxContainer/components/Title';
import { KeyValueWidget } from 'components/KeyValueWidget';

import IntlMessages from 'util/IntlMessages';

import { filtersProptype } from '../../../../../utils/proptypes/charts';
import { FIELD_FORM_IDS } from '../../metricsFilterConfig';
import {
  GROUP_BY_OPTIONS,
  RELATIVE_ABSOLUTE,
  RELATIVE_DATE_PER_DEFAULT,
  RELATIVE_OPTIONS,
} from './constants';
import styles from './styles.module.less';

const { RangePicker } = DatePicker;

const isRelativeMode = rel =>
  rel != null && typeof rel === 'object' && (rel.isRelative === true || rel.isRelative === 'true');

const ChartFilters = ({ handleFilters, filters }) => {
  const intl = useIntl();
  const parserDates = event => {
    const { value } = event.target;
    const { dateType } = RELATIVE_OPTIONS.find(e => e.value === value);

    return {
      isRelative: true,
      dateType,
      relativeAmount: value,
    };
  };
  const disabledDate = disableCalendarDatesAfterToday;
  const relative = filters.relative === undefined ? RELATIVE_DATE_PER_DEFAULT : filters.relative;
  const dateRange = filters.dateRange;
  const groupBy = filters.groupBy;
  const groupBySelectValue = groupBy === null || groupBy === '' ? undefined : groupBy;

  const fromByDefault = moment().subtract(7, 'days');
  const rangeSource =
    Array.isArray(dateRange) && dateRange.length === 2 ? dateRange : [fromByDefault, moment()];
  const dateRangeFormated = [moment(rangeSource[0]), moment(rangeSource[1])];
  const rangePickerValue = dateRange === null ? null : dateRangeFormated;
  const isRelative = isRelativeMode(relative);
  const pickerDateType = relative?.dateType || RELATIVE_DATE_PER_DEFAULT.dateType;

  const inputSize = 'middle';

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <KeyValueWidget
          label={<Title.Filter value={<IntlMessages id="dashboards.chart.creation.date" />} />}
          value={
            <div className="gx-flex-row gx-guarnic-gap-1">
              <div className="gx-flex-1">
                <Radio.Group
                  id={FIELD_FORM_IDS.RELATIVE}
                  className="gx-w-100"
                  onChange={e => {
                    const nextIsRelative = e.target.value === true || e.target.value === 'true';
                    if (nextIsRelative) {
                      handleFilters({
                        key: FIELD_FORM_IDS.RELATIVE,
                        value: {
                          ...RELATIVE_DATE_PER_DEFAULT,
                          isRelative: true,
                        },
                      });
                      handleFilters({
                        key: FIELD_FORM_IDS.DATE_RANGE,
                        value: null,
                      });
                      return;
                    }

                    handleFilters({
                      key: FIELD_FORM_IDS.RELATIVE,
                      value: null,
                    });
                    handleFilters({
                      key: FIELD_FORM_IDS.DATE_RANGE,
                      value: [fromByDefault, moment()],
                    });
                  }}
                  value={isRelative}
                  size={inputSize}
                >
                  {RELATIVE_ABSOLUTE.map(({ label, value }) => (
                    <Radio.Button className="gx-w-50" key={label} value={value}>
                      <span style={{ fontSize: '12px' }}>
                        <IntlMessages id={`dashboards.schedules.${label}`} />
                      </span>
                    </Radio.Button>
                  ))}
                </Radio.Group>
              </div>
              <div className="gx-flex-1">
                {isRelative ? (
                  <Radio.Group
                    className="gx-w-100"
                    onChange={e =>
                      handleFilters({ key: FIELD_FORM_IDS.RELATIVE, value: parserDates(e) })
                    }
                    value={relative.relativeAmount}
                  >
                    {RELATIVE_OPTIONS.map(e => (
                      <Radio.Button style={{ width: '16.6%' }} key={e.label} value={e.value}>
                        {e.label}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                ) : (
                  <RangePicker
                    id={FIELD_FORM_IDS.DATE_RANGE}
                    size={inputSize}
                    picker={pickerDateType === 'day' ? 'date' : pickerDateType}
                    onChange={val => handleFilters({ key: FIELD_FORM_IDS.DATE_RANGE, value: val })}
                    disabledDate={disabledDate}
                    value={rangePickerValue}
                    className={styles.unRelativeInput}
                  />
                )}
              </div>
            </div>
          }
        />
      </Col>
      <Col span={24}>
        <KeyValueWidget
          label={<Title.Filter value={<IntlMessages id="dashboards.chart.group.by" />} />}
          value={
            <Select
              id={FIELD_FORM_IDS.GROUP_BY}
              allowClear
              style={{ width: '100%' }}
              placeholder={intl.formatMessage({ id: 'dashboards.chart.group.by' })}
              onChange={val => handleFilters({ key: FIELD_FORM_IDS.GROUP_BY, value: val })}
              value={groupBySelectValue}
              size={inputSize}
              className={classnames(styles.inputFilterMobile)}
            >
              {GROUP_BY_OPTIONS.map(item => (
                <Select.Option key={item}>
                  <IntlMessages id={`dateTypes.${item}`} values={{ amount: 1 }} />
                </Select.Option>
              ))}
            </Select>
          }
        />
      </Col>
    </Row>
  );
};

ChartFilters.propTypes = {
  filters: filtersProptype.isRequired,
  handleFilters: PropTypes.func.isRequired,
};

export default ChartFilters;
